import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Check, Phone } from "lucide-react";
import ElektraAanleggenHero from "../components/heroes/ElektraAanleggenHero";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import { generateServiceSchema } from "../lib/schema";
function Elektraaanleg() {
  return (
    <div className="min-h-screen bg-gray-50 page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektra aanleggen - Elektraaanleggen.nl"
        description="Van nieuwbouw tot uitbreiding: onze experts zorgen voor een veilige en toekomstbestendige elektrische installatie die voldoet aan de hoogste normen."
        schema={generateServiceSchema({
          name: "Elektra aanleggen",
          description:
            "Professionele elektrotechnische installaties voor zowel nieuwbouw als uitbreiding. Wij zorgen voor een veilige en toekomstbestendige stroomvoorziening, uitgevoerd door gecertificeerde elektriciens.",
          image: "https://elektraaanleggen.nl/images/banner.png",
        })}
      />
      <Header />
      <ElektraAanleggenHero />
      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Vakkundige elektra aanleg – Veilig, duurzaam en op maat
            </h2>
            <p>
              Of het nu gaat om een volledige nieuwbouwinstallatie, het
              uitbreiden van uw bestaande elektra, of het aanpassen van uw
              groepenkast, bij Elektra Aanleggen bent u verzekerd van een
              professionele en veilige installatie. Onze gecertificeerde
              elektriciens werken met de nieuwste technieken en zorgen voor een
              perfect functionerend en toekomstbestendig elektrisch systeem.
            </p>
            <br></br>
            <p>
              Wij werken volledig volgens de NEN 1010-normen, de standaard voor
              veilige en betrouwbare elektrische installaties. Daarnaast
              gebruiken we uitsluitend A-kwaliteit materialen, zodat uw
              elektra-installatie niet alleen voldoet aan de strengste
              veiligheidsvoorschriften, maar ook duurzaam en storingsvrij blijft
              functioneren.
            </p>
            <br></br>
            <p className="font-semibold">
              Onze diensten omvatten onder andere:
            </p>
            <ul className="space-y-3 mb-6">
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Volledige elektra aanleg bij nieuwbouw en renovaties
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Uitbreiding van groepenkasten en extra groepen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Installatie van 3-fase aansluitingen en krachtstroom
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Plaatsen van stopcontacten, verlichting en schakelaars
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Voorbereiding en installatie van inductiekookplaten en
                  laadpalen
                </span>
              </li>
              <li className="flex items-center gap-2">
                <Check className="w-5 h-5 text-[#F47B20]" />
                <span className="text-[#17354A]">
                  Advies en installatie van duurzame oplossingen zoals
                  zonnepanelen en energiezuinige verlichting
                </span>
              </li>
            </ul>
            <br></br>
            <p>
              Of u nu uw woning toekomstbestendig wilt maken, uw elektrische
              installatie wilt moderniseren of een nieuwe keuken of badkamer
              voorziet van de juiste stroompunten, wij bieden
              maatwerkoplossingen die perfect aansluiten op uw wensen.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Professionele elektra aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/groepenkast.png.jpeg"
              />
            </div>
          </div>
        </div>
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele installatie van stopcontacten
            </h2>
            <p>
              Het plaatsen van extra stopcontacten vereist vakkundig werk en een
              veilige installatie. Onze ervaren elektriciens zorgen ervoor dat
              elk stopcontact correct wordt aangesloten, volledig volgens de
              nieuwste NEN-normen. Of het nu gaat om het uitbreiden van uw
              woonkamer, keuken, slaapkamer, badkamer of werkruimte, wij
              plaatsen stopcontacten precies waar u ze nodig heeft.
            </p>
            <br></br>
            <p>
              Bij Elektra Aanleggen werken we uitsluitend met A-merk
              schakelmateriaal van Jung en Gira, bekend om hun duurzaamheid,
              kwaliteit en stijlvolle afwerking. We zorgen niet alleen voor een
              perfecte installatie, maar ook voor een nette afwerking met
              minimale overlast tijdens de werkzaamheden.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Slimme elektrische installaties"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/stopcontact-aansluiten.jpg"
              />
            </div>
          </div>
        </div>
      </section>
      <ServicesOverview />
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Krachtstroom aanleggen
            </h2>
            <p>
              Heeft u zware elektrische apparatuur zoals een laadpaal, sauna,
              warmtepomp, elektrische boiler of industriële machines? Dan is een
              krachtstroomaansluiting (400V, 3-fase) essentieel om overbelasting
              en storingen te voorkomen. Een standaard 1-fase aansluiting (230V)
              biedt vaak niet voldoende vermogen voor deze toepassingen,
              waardoor een upgrade naar krachtstroom nodig is.
            </p>
            <br></br>
            <p>
              Onze gecertificeerde elektriciens verzorgen een veilige en
              vakkundige installatie van uw krachtstroomaansluiting, volledig
              volgens de nieuwste NEN 1010-normen. We zorgen voor een correcte
              uitbreiding van uw meterkast, groepenkast en bekabeling, en werken
              uitsluitend met hoogwaardige materialen voor een betrouwbare en
              duurzame installatie.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="krachtstroom aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/401034144.webp" // Replace with your krachtstroom image
              />
            </div>
          </div>
        </div>
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Meterkast aanleggen
            </h2>
            <p>
              Uw meterkast is het centrale punt van uw elektrische installatie
              en moet niet alleen veilig, maar ook toekomstbestendig zijn. Of
              het nu gaat om een nieuwe meterkast of een uitbreiding van uw
              bestaande installatie, bij Elektra Aanleggen zorgen wij voor een
              vakkundige en veilige installatie, volledig volgens de NEN
              1010-normen.
            </p>
            <br></br>
            <p>
              Met de groeiende vraag naar stroom door inductiekookplaten,
              laadpalen, warmtepompen en zonnepanelen is een goed ingerichte
              meterkast essentieel. Misschien wilt u extra groepen, een overstap
              van 1-fase naar 3-fase krachtstroom, of een verouderde groepenkast
              vervangen. Wij zorgen voor een slimme indeling, de juiste
              beveiliging en een betrouwbare installatie met A-kwaliteit
              materialen.
            </p>
            <br></br>
            <p>
              Bij ons krijgt u deskundig advies en een duidelijke prijsindicatie
              vooraf. We werken snel, netjes en met minimale overlast.
            </p>
            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">Gratis offerte</span>
              </Link>
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Professionele meterkast aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/Aanvragen-3-Fase-aansluiting-1-removebg-preview.png" // Replace with your meterkast image
              />
            </div>
          </div>
        </div>
      </section>
      <FAQ />
      <ServiceHighlights />
      <Reviews />
      <PartnerMarquee />
      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#2FB6D2] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1260px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Gratis offerte
            </div>
          </section>
        </Link>
      </div>
      <HelpButton />
      <Footer />
    </div>
  );
}
export default Elektraaanleg;
